import dayjs from 'dayjs'
export const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  try {
    const d = new Date(date)
    return dayjs(d).format(format)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('parse Date error，source date is ', date)
  }
  return dayjs
}

const unitToSecond = {
  ms: 1 / 1000,
  s: 1,
  m: 60,
  h: 60 * 60,
  d: 60 * 60 * 24,
}
const Renders = ['d', 'h', 'm', 's'] as const

export const formatDuration = (duration: number, unit: keyof typeof unitToSecond = 's') => {
  let second = duration * unitToSecond[unit]
  const [d, ...times] = Renders.map((u) => {
    const num = Math.floor(second / unitToSecond[u])
    second = second % unitToSecond[u]
    return num
  })
  const timeStr = times.map((t) => `${t}`.padStart(2, '0')).join(':')
  if (d) {
    return `${d}d ${timeStr}`
  }
  return timeStr
}
